export default __webpack_public_path__ + "static/media/BRA.dcc02bb7.svg";